import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/fetch';
import { environmentLookupFn } from '../../../environment/environment-instance';
import type {
  FetchAndRefetchConfig,
  ReadParameters,
  ReadRequestConfig,
  SubGeographiesVariables,
  SubGeography,
} from '../../../types';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);


export function useSubGeographies(
  dataLocator: SubGeographiesVariables,
  config: FetchAndRefetchConfig<SubGeography, SubGeographiesVariables> = {}
) {
  const dataRefId = useDataRefId(null, environmentLookupFn);

  const defaultConfig = useMemo(() => ({

    fetch: config.fetch || {},

    refetch: config.refetch || {},
  }), [config]);

  const { fetch: fetchConfig, refetch } = defaultConfig;

  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig) as [
    SubGeography[] | undefined,
    unknown,
  ];
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetch);

  const read = useCallback((
    param: ReadParameters<SubGeographiesVariables> = {},
    requestConfig?: ReadRequestConfig<SubGeography, SubGeographiesVariables>
  ) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    }, requestConfig);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { read }];
}
